module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-17.e4fb2062.jpg";